<div data-automation-id="epub-controls" role="group" aria-label="Media Controls">
  @if (enableTTS) {
    <div class="button-group">
      <rdrx-page-tts-controls class="tts-controls"></rdrx-page-tts-controls>
    </div>
  }

  @if (showReadSpeakerVoicePick) {
    <div
      class="button-group button-voice-picker"
      >
      <rdrx-tts-voice-picker></rdrx-tts-voice-picker>
    </div>
  }

  <!-- AI READER SECTION -->
  @if (isAiAssistOffered) {
    <div class="button-group button-group-sm ai-assist">
    <button
      data-automation-id="epub-controls-ai-assist-button"
      mhe-button
      class="aiAssistButton"
      id="ai-assist-button-control"
      aria-controls="ngx-ai-assist-panel"
      [attr.aria-label]="'ai_tools.reader.button' | translate"
      [attr.aria-expanded]="isAiAssistOpen$ | async"
      [purpose]="ButtonPurpose.Icon"
      (click)="onClickAiAssist()"
      [mheTooltip]="'ai_tools.reader.button' | translate"
      placement="left"
    >
      <i class="ai-assist ai-assist-icon bigger"></i>
    </button>
  </div>
  }

  <!-- AI SUMMARY SECTION (Learning Studio) -->
  @if (featureTogglesService.learningStudioEnabled$ | async) {
    @if (isAiSummaryOffered) {
      <div class="button-group button-group-sm ai-summary">
      <button
        data-automation-id="epub-controls-ai-summary-button"
        mhe-button
        class="aiSummaryButton"
        id="ai-summary-button-control"
        aria-controls="ngx-ai-summary-panel"
        aria-labelledby="ai-summary-button-sr-label"
        [purpose]="ButtonPurpose.Icon"
        (click)="onAiSummaryClick()"
        [mheTooltip]="'ai_tools.ai_summary.tooltip' | translate"
        placement="left"
      >
        <span id="ai-summary-button-sr-label" class="sr-only">{{ 'ai_tools.ai_summary.sr_label' | translate }}</span>
        <svg class="ai-summary ai-summary-icon bigger" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <g>
            <path
              d="M 20.7998 0 C 21.6485 0 22.4624 0.3163060000000001 23.0625 0.8789060000000002 C 23.6626 1.4415200000000001 24 2.20435 24 3 L 24 21 C 24 21.7956 23.6626 22.5585 23.0625 23.1211 C 22.4624 23.6837 21.6485 24 20.7998 24 L 4.7998 24 C 3.95118 24 3.13718 23.6837 2.53711 23.1211 C 1.93711 22.5585 1.59961 21.7956 1.59961 21 L 1.59961 19.5 L 3.2002 19.5 L 3.2002 21 C 3.2002 21.3978 3.36889 21.7792 3.6689499999999997 22.0605 C 3.96895 22.3417 4.37558 22.5 4.7998 22.5 L 20.7998 22.5 C 21.2242 22.5 21.6316 22.3419 21.9316 22.0605 C 22.2316 21.7793 22.4004 21.3977 22.4004 21 L 22.4004 3 C 22.4004 2.60226 22.2316 2.22074 21.9316 1.93945 C 21.6316 1.65815 21.2242 1.5 20.7998 1.5 L 4.7998 1.5 C 4.37558 1.5000499999999999 3.96895 1.6582599999999998 3.6689499999999997 1.93945 C 3.36889 2.22076 3.2002 2.6021799999999997 3.2002 3 L 3.2002 4.5 L 1.59961 4.5 L 1.59961 3 C 1.59961 2.20444 1.93711 1.4415 2.53711 0.8789060000000002 C 3.13718 0.31634 3.95118 0.0000485061 4.7998 0 L 20.7998 0 Z"
              fill="#275867" />
            <path
              d="M 2.40039 6 C 2.61242 6.0001 2.81588 6.07916 2.96582 6.21973 C 3.11579 6.36037 3.2002 6.55113 3.2002 6.75 L 3.2002 7.5 L 4 7.5 C 4.21212 7.5 4.41541 7.57914 4.56543 7.71973 C 4.71546 7.86038 4.7998 8.05109 4.7998 8.25 C 4.7998 8.44891 4.71546 8.63962 4.56543 8.78027 C 4.41541 8.92086 4.21212 9 4 9 L 0.799805 9 C 0.587704 8.99995 0.3843580000000001 8.92088 0.234375 8.78027 C 0.0843459 8.63962 0 8.44891 0 8.25 C 0 8.05109 0.0843459 7.86038 0.234375 7.71973 C 0.3843580000000001 7.57912 0.587704 7.50005 0.799805 7.5 L 1.59961 7.5 L 1.59961 6.75 C 1.59961 6.5511800000000004 1.6840799999999998 6.36036 1.83398 6.21973 C 1.98401 6.07907 2.18822 6 2.40039 6 Z"
              fill="#275867" />
            <path
              d="M 2.40039 10.5 C 2.61242 10.5001 2.81588 10.5792 2.96582 10.7197 C 3.11579 10.8604 3.2002 11.0511 3.2002 11.25 L 3.2002 12 L 4 12 C 4.21212 12 4.41541 12.0791 4.56543 12.2197 C 4.71546 12.3604 4.7998 12.5511 4.7998 12.75 C 4.7998 12.9489 4.71546 13.1396 4.56543 13.2803 C 4.41541 13.4209 4.21212 13.5 4 13.5 L 0.799805 13.5 C 0.587704 13.5 0.3843580000000001 13.4209 0.234375 13.2803 C 0.0843459 13.1396 0 12.9489 0 12.75 C 0 12.5511 0.0843459 12.3604 0.234375 12.2197 C 0.3843580000000001 12.0791 0.587704 12 0.799805 12 L 1.59961 12 L 1.59961 11.25 C 1.59961 11.0512 1.6840799999999998 10.8604 1.83398 10.7197 C 1.98401 10.5791 2.18822 10.5 2.40039 10.5 Z"
              fill="#275867" />
            <path
              d="M 2.40039 15 C 2.61242 15.0001 2.81588 15.0792 2.96582 15.2197 C 3.11579 15.3604 3.2002 15.5511 3.2002 15.75 L 3.2002 16.5 L 4 16.5 C 4.21212 16.5 4.41541 16.5791 4.56543 16.7197 C 4.71546 16.8604 4.7998 17.0511 4.7998 17.25 C 4.7998 17.4489 4.71546 17.6396 4.56543 17.7803 C 4.41541 17.9209 4.21212 18 4 18 L 0.799805 18 C 0.587704 18 0.3843580000000001 17.9209 0.234375 17.7803 C 0.0843459 17.6396 0 17.4489 0 17.25 C 0 17.0511 0.0843459 16.8604 0.234375 16.7197 C 0.3843580000000001 16.5791 0.587704 16.5 0.799805 16.5 L 1.59961 16.5 L 1.59961 15.75 C 1.59961 15.5512 1.6840799999999998 15.3604 1.83398 15.2197 C 1.98401 15.0791 2.18822 15 2.40039 15 Z"
              fill="#275867" />
          </g>
          <g>
            <path
              class="ai-summary-sparkle ai-summary-sparkle-small"
              d="M 17.4004 4.50098 C 17.4304 4.50105 17.4599 4.51006 17.4844 4.52637 C 17.5089 4.54275 17.5273 4.56612 17.5371 4.59277 L 17.7949 5.31836 C 17.9099 5.64273 18.1813 5.89707 18.5273 6.00488 L 19.3008 6.24609 C 19.3293 6.25535 19.3546 6.27288 19.3721 6.2959 C 19.3895 6.31891 19.3984 6.34676 19.3984 6.375 C 19.3984 6.40324 19.3895 6.43109 19.3721 6.4541 C 19.3546 6.47712 19.3293 6.49465 19.3008 6.50391 L 18.5273 6.74512 C 18.3568 6.7983 18.2013 6.88869 18.0742 7.00781 C 17.9473 7.12687 17.8516 7.27195 17.7949 7.43164 L 17.5371 8.15723 C 17.5273 8.18388 17.5089 8.20725 17.4844 8.22363 C 17.4599 8.23994 17.4304 8.24895 17.4004 8.24902 C 17.3704 8.24902 17.3409 8.23983 17.3164 8.22363 C 17.2919 8.20725 17.2726 8.18392 17.2627 8.15723 L 17.0049 7.43164 C 16.9482 7.2719000000000005 16.8525 7.12689 16.7256 7.00781 C 16.5986 6.88877 16.4438 6.79831 16.2734 6.74512 L 15.5 6.50391 C 15.4717 6.4947 15.4471 6.47695 15.4297 6.4541 C 15.4122 6.43108 15.4023 6.40325 15.4023 6.375 C 15.4023 6.34675 15.4122 6.31892 15.4297 6.2959 C 15.4471 6.27305 15.4717 6.2553 15.5 6.24609 L 16.2744 6.00488 C 16.6203 5.89701 16.8909 5.6426300000000005 17.0059 5.31836 L 17.2627 4.59375 L 17.2627 4.59277 C 17.2726 4.56608 17.2919 4.54275 17.3164 4.52637 C 17.3409 4.5101700000000005 17.3704 4.50098 17.4004 4.50098 Z"
              fill="#009BB5" />
            <path
              class="ai-summary-sparkle ai-summary-sparkle-medium"
              d="M 10.4004 5.43652 C 10.4459 5.4366 10.4905 5.45062 10.5273 5.47559 C 10.5642 5.50061 10.5921 5.5357 10.6064 5.57617 L 10.9932 6.66602 C 11.1662 7.15143 11.572 7.53218 12.0898 7.69434 L 13.252 8.05664 C 13.2952 8.07006 13.332699999999999 8.09628 13.3594 8.13086 C 13.3861 8.16553 13.4004 8.20723 13.4004 8.25 C 13.4004 8.29277 13.3861 8.33447 13.3594 8.36914 C 13.332699999999999 8.40372 13.2952 8.42994 13.252 8.44336 L 12.0898 8.80566 C 11.8345 8.88542 11.6024 9.01989 11.4121 9.19824 C 11.2218 9.37665 11.0783 9.59463 10.9932 9.83398 L 10.6064 10.9238 C 10.5921 10.9643 10.5642 10.9994 10.5273 11.0244 C 10.4905 11.0494 10.4459 11.0634 10.4004 11.0635 C 10.354800000000001 11.0635 10.3094 11.0495 10.2725 11.0244 C 10.2358 10.9994 10.2086 10.9642 10.1943 10.9238 L 9.80664 9.83398 C 9.7215 9.59466 9.57798 9.37664 9.3877 9.19824 C 9.19736 9.01993 8.96525 8.8854 8.70996 8.80566 L 7.54785 8.44336 C 7.50461 8.42992 7.46712 8.40375 7.44043 8.36914 C 7.41372 8.33447 7.39941 8.29277 7.39941 8.25 C 7.39941 8.20723 7.41372 8.16553 7.44043 8.13086 C 7.46712 8.09625 7.50461 8.07008 7.54785 8.05664 L 8.70996 7.69434 C 8.96525 7.6146 9.19736 7.48007 9.3877 7.30176 C 9.57798 7.12336 9.7215 6.90534 9.80664 6.66602 L 10.1943 5.57617 C 10.2086 5.53582 10.2358 5.50057 10.2725 5.47559 C 10.3094 5.45055 10.354800000000001 5.43652 10.4004 5.43652 Z"
              fill="#009BB5" />
            <path
              class="ai-summary-sparkle ai-summary-sparkle-large"
              d="M 14.0566 10.3564 C 14.1666 10.0471 14.6331 10.0471 14.7432 10.3564 L 15.3877 12.1729 C 15.5297 12.5719 15.7695 12.934 16.0869 13.2314 C 16.4044 13.5289 16.7909 13.7538 17.2168 13.8867 L 19.1533 14.4912 C 19.4828 14.5945 19.4828 15.0305 19.1533 15.1338 L 17.2158 15.7383 C 16.79 15.8714 16.4032 16.096 16.0859 16.3936 C 15.7687 16.6911 15.5294 17.0539 15.3877 17.4531 L 14.7432 19.2686 C 14.7194 19.3363 14.6729 19.3947 14.6113 19.4365 C 14.549900000000001 19.4782 14.4763 19.5009 14.4004 19.501 C 14.324300000000001 19.501 14.2501 19.4783 14.1885 19.4365 C 14.1269 19.3947 14.0803 19.3363 14.0566 19.2686 L 13.4121 17.4521 C 13.270199999999999 17.0532 13.031 16.6909 12.7139 16.3936 C 12.3966 16.0961 12.0097 15.8713 11.584 15.7383 L 9.64746 15.1338 C 9.5752 15.1116 9.51141 15.0685 9.4668 15.0107 C 9.42237 14.9531 9.39844 14.8836 9.39844 14.8125 C 9.39844 14.7414 9.42237 14.6719 9.4668 14.6143 C 9.51141 14.5565 9.5752 14.5134 9.64746 14.4912 L 11.584 13.8867 C 12.0097 13.7537 12.3966 13.5289 12.7139 13.2314 C 13.031 12.9341 13.270199999999999 12.5718 13.4121 12.1729 L 14.0566 10.3564 Z"
              fill="#009BB5" />
          </g>
        </svg>
      </button>
    </div>
      <div class="badge ai-summary-badge" aria-hidden="true">Beta</div>
    }
  }

</div>

@if (readerStore.showAnnotateButton$ | async) {
  <div class="button-group button-group-sm">
    <button
      data-automation-id="epub-controls-annotate-mobile-button"
      mhe-button
      [purpose]="ButtonPurpose.Icon"
      (click)="annotateSelectionOnMobile()"
      [mheTooltip]="'navigation.highlight_button' | translate"
      >
      <i class="dpg-icon dpg-icon-highlighter"></i>
    </button>
  </div>
}

<!-- Caret-browsing selection hint: positioned above selected text for keyboard users -->
@if (readerStore.caretSelectionHintState$ | async; as hintPos) {
  <span
    class="caret-selection-hint"
    [mheTooltip]="'context.caret_selection_hint' | translate"
    placement="top"
    #caretHintTooltip="mheTooltip"
    [style.top.px]="hintPos.top"
    [style.left.px]="hintPos.left"
    data-automation-id="caret-selection-hint"
    aria-hidden="true"
  ></span>
}

@if (isFixedLayout || (isFplSpine$ | async)) {
  <div class="button-group bottom-button-group">
    @if (isDoubleSpread && (ribac$ | async) === false && isSinglePageViewOnly === false) {
      <button
        data-automation-id="epub-controls-album-mode-button"
        [disabled]="isAlbumModeForced$ | async"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="albumModeLabel"
        (click)="onToggleAlbumMode()"
        >
        <i
          class="dpg-icon"
          [class.dpg-icon-box-one-arrow-in-left]="!albumMode"
          [class.dpg-icon-boxes-two-arrow-in-left]="albumMode"
        ></i>
      </button>
    }
    @if (albumMode || !isDoubleSpread) {
      <button
        data-automation-id="epub-controls-zoom-in-button"
        [disabled]="!increaseEpubZoomEnabled"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="'iframe.zoom_in_page' | translate"
        (click)="increaseZoomLevel()"
        >
        <i class="dpg-icon dpg-icon-magnifying-glass-plus-symbol"></i>
      </button>
      <p class="zoom-display" data-automation-id="epub-controls-zoom-display" [attr.aria-label]="'iframe.zoom_level' | translate" aria-live="polite">{{ zoomDisplay }}</p>
      <button
        data-automation-id="epub-controls-zoom-out-button"
        [disabled]="!decreaseEpubZoomEnabled"
        mhe-button
        [purpose]="ButtonPurpose.Icon"
        [mheTooltip]="'iframe.zoom_out_page' | translate"
        (click)="decreaseZoomLevel()"
        >
        <i class="dpg-icon dpg-icon-magnifying-glass-minus-symbol"></i>
      </button>
      @if (zoomLevel > 1) {
        <button
          data-automation-id="epub-controls-move-up-button"
          class="btn-arrow-icon"
          mhe-button
          [disabled]="!enableUpArrow"
          [purpose]="ButtonPurpose.Icon"
          (click)="moveEpubOnClick('up')"
          [mheTooltip]="'iframe.move_page_up' | translate"
          >
          <i class="dpg-icon dpg-icon-up-arrow"></i>
        </button>
        <button
          data-automation-id="epub-controls-move-down-button"
          class="btn-arrow-icon"
          mhe-button
          [disabled]="!enableDownArrow"
          [purpose]="ButtonPurpose.Icon"
          (click)="moveEpubOnClick('down')"
          [mheTooltip]="'iframe.move_page_down' | translate"
          >
          <i class="dpg-icon dpg-icon-down-arrow"></i>
        </button>
        <button
          data-automation-id="epub-controls-move-right-button"
          class="btn-arrow-icon"
          mhe-button
          [disabled]="!enableRightArrow"
          [purpose]="ButtonPurpose.Icon"
          (click)="moveEpubOnClick('right')"
          [mheTooltip]="'iframe.move_page_right' | translate"
          >
          <i class="dpg-icon dpg-icon-right-arrow"></i>
        </button>
        <button
          data-automation-id="epub-controls-move-left-button"
          class="btn-arrow-icon"
          mhe-button
          [disabled]="!enableLeftArrow"
          [purpose]="ButtonPurpose.Icon"
          (click)="moveEpubOnClick('left')"
          [mheTooltip]="'iframe.move_page_left' | translate"
          >
          <i class="dpg-icon dpg-icon-system-left-arrow"></i>
        </button>
      }
    }
  </div>
}
